import React from 'react'
import Modal from '../../../../../components/prime-react-overrides/modal/Modal'
import Male from '../../../../../assets/recruitment/Onboarding/Male.png'
import Female from "../../../../../assets/recruitment/Onboarding/Female.png"
function ViewSampleModal({ onShow, onHide }) {
  return (
    <Modal header = 'Sample' visible={onShow} onHide={onHide} draggable={false} breakpoints={{ '640px': '100vw' }} style={{ width: '25w' }}>
      <div className='flex flex-row justify-content-center mt-2'>
        <img src={Female} className='mr-4' />
        <img src={Male} />
      </div>
      <div className='flex flex-column  text-sm font-light  mt-3'>
        <ul className='p-0 my-1'>• Wear appropriate professional or business casual attire.</ul>
        <ul className='p-0 my-1'>• Keep your head straight and upright.</ul>
        <ul className='p-0 my-1'>• Image format should be .jpg, .png or .jpeg only.</ul>
        <ul className='p-0 my-1'>• Image size can be 5MB max.</ul>
      </div>
    </Modal>
  )
}

export default ViewSampleModal